export function deferredScript() {
    $('.bg-load').each(function () {
        var lazy = $(this);
        var src = lazy.attr('data-bg');
        lazy.css('background-image', 'url("' + src + '")').removeAttr('data-bg').removeClass('bg-load');
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/deferred-script.js